var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TreatsSEOSchemaJson } from '@content/products/extras';
import { buildYourBoxFeaturetteContent, mealPromoContent, treatThemRightHeroSectionContent, treatsPLPReviewsContent, treatsProductListingContent, } from '@marketing/components/sections/content';
import { SingleImageHeroSection } from '@marketing/components/sections/heroes/HeroSection';
import Featurette from '@marketing/components/sections/non_product/Featurette';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import ReviewsSection from '@marketing/components/sections/non_product/carousels/Reviews';
import MealPromo from '@marketing/components/sections/product/MealPromo';
import ProductListing from '@marketing/components/sections/product/ProductListing';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGoogleTagManagerEvent } from '@trackers';
var TreatsProductListing = function () {
    useEffect(function () {
        sendGoogleTagManagerEvent({
            event: 'view-treats',
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Healthy Dog Treats | Nom Nom" }), _jsx("meta", { name: "description", content: "Healthy dog treats are a great way to engage your dog & add excitement between meal times." }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/other-products/treats" }), _jsx("script", __assign({ type: "application/ld+json" }, { children: JSON.stringify(TreatsSEOSchemaJson) }))] }), _jsxs("div", __assign({ className: "header-lining bg-surface-beige" }, { children: [_jsx(SingleImageHeroSection, { content: treatThemRightHeroSectionContent, headingLevel: "h1" }), _jsx(ProductListing, { content: treatsProductListingContent, pageName: "treats_plp" }), _jsx(MealPromo, { content: mealPromoContent.treatsPLP, backgroundColorStyle: "bg-surface-white", stacked: false, tileBackgroundVariant: "beige", pageName: "treats_plp" }), _jsx(Featurette, { content: buildYourBoxFeaturetteContent, backgroundColorStyle: "bg-action-surface-primary", flip: true }), _jsx(ReviewsSection, { content: treatsPLPReviewsContent }), _jsx(Newsletter, {})] }))] }));
};
export default TreatsProductListing;
